<template>
  <div>
    <div class="orderMain">
      <el-tabs type="border-card" @tab-click="changetab" v-model="tabCard">
        <el-tab-pane label="订单列表" name="ordersName"> </el-tab-pane>
        <el-tab-pane label="储物寄存" name="storageName">
          <div class="mb15">
            <span>寄存类型：</span>
            <el-select
              v-model="storageForm.returnStatus"
              @change="changeCheck"
              size="small"
            >
              <el-option
                v-for="item in checkSelectData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <el-form :inline="true" :model="storageForm">
            <el-form-item label="会员姓名或电话：">
              <el-input
                clearable
                size="small"
                v-model="storageForm.queryMember"
                placeholder="请输入会员姓名或电话"
                @input="changInpput"
              ></el-input>
            </el-form-item>
            <el-form-item label="近期到期：" class="ml15">
              <el-button type="primary" size="mini" @click="changeTime(7)">
                近7天到期</el-button
              >
              <el-button type="primary" size="mini" @click="changeTime(30)">
                近30天到期</el-button
              >
              <el-button type="primary" size="mini" @click="changeTime('all')">
                全部</el-button
              >
            </el-form-item>
          </el-form>
          <div class="flex">
            <div></div>
            <el-button
              size="small"
              type="primary"
              @click="openStorageDialog"
              class="btnClass"
            >
              创建
            </el-button>
          </div>
          <el-table :data="storageData">
            <el-table-column
              type="index"
              width="50"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="memberName"
              label="会员姓名"
              align="center"
              key="memberName"
            >
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.memberName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberPhone"
              label="手机号码"
              align="center"
              key="memberPhone"
            >
            </el-table-column>
            <el-table-column
              prop="shopName"
              label="门店"
              align="center"
              key="shopName"
            >
            </el-table-column>
            <el-table-column
              prop="createBy"
              label="归属人"
              align="center"
              key="createBy"
            >
            </el-table-column>
            <el-table-column
              prop="saveStartDate"
              label="寄存日期"
              align="center"
              key="saveStartDate"
            >
            </el-table-column>
            <el-table-column
              prop="saveEndDate"
              label="到期日期"
              align="center"
              key="saveEndDate"
            >
            </el-table-column>
            <el-table-column
              prop="updateDate"
              v-if="storageForm.returnStatus == '1'"
              label="退租日期"
              align="center"
              key="updateDate"
            >
            </el-table-column>
            <el-table-column
              prop="updateBy"
              v-if="storageForm.returnStatus == '1'"
              label="退租操作人"
              align="center"
              key="updateBy"
            >
            </el-table-column>
            <el-table-column
              v-if="storageForm.returnStatus == '0'"
              prop="timeRemaining"
              label="剩余天数"
              align="center"
              key="timeRemaining"
            >
            </el-table-column>
            <el-table-column
              prop="cashPledge"
              label="押金"
              align="center"
              key="cashPledge"
            >
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.cashPledge }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              v-if="storageForm.returnStatus == '0'"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onMoney(scope.row)">
                  续约
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="openBackMoney(scope.row)"
                >
                  退租
                </el-button>
                <!-- <el-button
                  type="text"
                  size="small"
                  @click="openDetailsDialog"
                  v-if="storageForm.returnStatus == 1"
                >
                  详情
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pageClass"
            @size-change="SizeChange"
            @current-change="ckCurrentChange"
            layout="total,prev, pager,next,sizes"
            :current-page.sync="ckResult.current"
            :page-size="ckResult.size"
            :total="ckResult.total"
            :page-sizes="[10, 20, 30, 40, 50]"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

      <el-dialog
        title="储物寄存"
        :visible.sync="storageDialog"
        width="40%"
        :before-close="storageDialogClose"
        :close-on-click-modal="false"
      >
        <div class="positionR">
          <el-form
            class="width70"
            label-width="100px"
            :model="createCheckFrom"
            ref="createCheckFroms"
          >
            <el-form-item label="搜索会员：" prop="membersId">
              <el-select
                v-model="createCheckFrom.membersId"
                filterable
                remote
                placeholder="请输入会员名称/电话"
                :remote-method="remoteMethod"
                :loading="loading"
                @change="pitchMember"
              >
                <el-option
                  v-for="item in dimMemberList"
                  :key="item.value"
                  :label="item.title"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会员名称：" prop="memberName">
              <el-input
                v-model="memberName"
                placeholder="会员名称"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员电话：" prop="memberPhone">
              <el-input
                v-model="memberPhone"
                placeholder="会员电话"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="归属人：" prop="createBy">
              <el-select
                v-model="createCheckFrom.createBy"
                placeholder="请选择归属人"
              >
                <el-option
                  v-for="item in createUserList"
                  :key="item.userId"
                  :label="item.realname"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="租赁期限：" prop="days">
              <el-radio-group
                v-model="createCheckFrom.days"
                size="small"
                @change="changeRadio"
              >
                <el-radio-button :label="30">1月</el-radio-button>
                <el-radio-button :label="90">3月</el-radio-button>
                <el-radio-button :label="180">6月</el-radio-button>
                <el-radio-button :label="365">1年</el-radio-button>
                <el-radio-button :label="730">2年</el-radio-button>
                <el-radio-button label="everyNnum">自定义</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自定义期限：" v-if="showeveryNum">
              <el-input v-model="selfNum" class="width70"></el-input>
            </el-form-item>
            <el-form-item label="类型：" prop="storageType">
              <el-radio-group
                v-model="createCheckFrom.storageType"
                size="small"
              >
                <el-radio-button
                  v-for="item in storageTypeList"
                  :key="item.value"
                  :label="item.value"
                  >{{ item.title }}</el-radio-button
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="押金：" prop="cashPledge">
              <el-input
                v-model="createCheckFrom.cashPledge"
                class="width70"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="storagePhoto">
            <img v-if="memberImg" :src="globelurls + memberImg" alt="" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addStorageRegister">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="退租"
        :visible.sync="backMoney"
        width="30%"
        :before-close="backMoneyClose"
        :close-on-click-modal="false"
      >
        <el-form :model="retrogradationForm" label-width="100px">
          <el-form-item label="操作人：" class="width70">
            <el-select
              v-model="retrogradationForm.updateBy"
              placeholder="请选择操作人"
            >
              <el-option
                v-for="item in createUserList"
                :key="item.userId"
                :label="item.realname"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间：">
            <el-date-picker
              v-model="retrogradationForm.updateDate"
              type="datetime"
              format="yyyy-MM-dd hh:mm:ss"
              value-format="yyyy-MM-dd hh:mm:ss"
              placeholder="请选择时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="backMoneyTure">确 定</el-button>
        </span>
      </el-dialog>
      <!-- <el-dialog
        title="详情"
        :visible.sync="detailsDialog"
        width="30%"
        :before-close="detailsDialogClose"
        :close-on-click-modal="false"
      >
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp"
          >
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="detailsDialogClose"
            >确 定</el-button
          >
        </span>
      </el-dialog> -->
      <el-dialog
        title="续约"
        :visible.sync="onMoneyDialog"
        width="30%"
        :before-close="onMoneyDialogClose"
        :close-on-click-modal="false"
      >
        <span>续约时长：</span>
        <el-radio-group v-model="onDays" size="small">
          <el-radio-button :label="30">1月</el-radio-button>
          <el-radio-button :label="90">3月</el-radio-button>
          <el-radio-button :label="180">6月</el-radio-button>
          <el-radio-button :label="365">1年</el-radio-button>
          <el-radio-button :label="730">2年</el-radio-button>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="renew">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { globelurl } from "../../api/axios";
import {
  getStorageRegisterList,
  getUserForSelect,
  getStorageType,
  getMemberById,
  getMembersInfo,
  addStorageRegister,
  refundDeposit,
  renew,
} from "@/api/OrderManagement.js";
export default {
  name: "OrderManager",
  data() {
    return {
      tabCard: "storageName",
      checkSelectData: [
        //寄存类型
        {
          value: "0",
          label: "寄存订单",
        },
        {
          value: "1",
          label: "退租订单",
        },
      ],
      storageForm: {
        //筛选表单
        returnStatus: "0", //寄存类型
        queryMember: "",
        days: "",
        pageNo: 1,
        pageSize: 10,
      },
      ckResult: {}, //分页
      storageData: [],
      //创建寄存表单弹窗
      storageDialog: false,
      memberName: "",
      memberPhone: "",
      loading: false,
      //创建寄存订单表单
      createCheckFrom: {
        membersId: "",
        createBy: "",
        days: "", //租赁期限
        storageType: "", //寄存类型
        cashPledge: "", //押金
        shopId: sessionStorage.shopId,
      },
      dimMemberList: [], //会员模糊option
      createUserList: [], //归属人下拉
      storageTypeList: [], //寄存类型
      memberImg: "",
      globelurls: globelurl,
      backMoney: false, //退租弹窗
      id: "", //退租id
      retrogradationForm: {
        updateBy: "",
        updateDate: "",
      },
      // detailsDialog: false,
      // activities: [
      //   {
      //     content: "寄存日期",
      //     timestamp: "2020-08-08",
      //   },
      //   {
      //     content: "到期日期",
      //     timestamp: "2021-08-07",
      //   },
      //   {
      //     content: "退租日期",
      //     timestamp: "2021-07-07",
      //   },
      // ],
      onMoneyDialog: false,
      onDays: "",
      showeveryNum: false,
      selfNum: "",
    };
  },
  mounted() {
    this.getStorageRegisterList();
  },
  methods: {
    changetab(tab) {
      if (tab.label == "订单列表") {
        this.$router.push("/OrderManagement/OrderTypes");
      }
    },
    // 切换寄存类型
    changeCheck(val) {
      val == 1
        ? this.$set(this.storageForm, "returnStatus", "1")
        : this.$set(this.storageForm, "returnStatus", "0");
      this.storageForm.pageNo = 1;
      this.getStorageRegisterList();
    },
    changInpput() {
      this.storageForm.pageNo = 1;
      this.getStorageRegisterList();
    },
    // 筛选近期到期
    changeTime(day) {
      day == "all"
        ? this.$set(this.storageForm, "days", "")
        : this.$set(this.storageForm, "days", day);
      this.storageForm.pageNo = 1;
      this.getStorageRegisterList();
    },
    SizeChange(newSize) {
      this.$set(this.storageForm, "pageSize", newSize);
      this.getStorageRegisterList();
    },
    //寄存列表切换页码
    ckCurrentChange(newPage) {
      this.$set(this.storageForm, "pageNo", newPage);
      this.getStorageRegisterList();
    },
    // 寄存列表
    getStorageRegisterList() {
      getStorageRegisterList({
        ...this.storageForm,
        shopId: sessionStorage.shopId,
      }).then((res) => {
        if (res.status === 200 && res.data.success) {
          if (res.data.result.total === 0) {
            this.$Notice.open({
              title: "查无数据",
            });
          } else {
            this.ckResult = res.data.result;
            this.storageData = res.data.result.records;
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 打开创建寄存订单弹窗
    openStorageDialog() {
      this.storageDialog = true;
      this.getUserForSelect();
      this.getStorageType();
    },
    // 归属人下拉
    getUserForSelect() {
      getUserForSelect({ shopId: sessionStorage.shopId }).then((res) => {
        if (res.status === 200 && res.data.success) {
          this.createUserList = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 寄存类型字典
    getStorageType() {
      getStorageType().then((res) => {
        if (res.status === 200 && res.data.success) {
          this.storageTypeList = res.data.result;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 创建订单搜索会员名称/电话
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          getMembersInfo({ queryValue: query }).then((res) => {
            if (res.status === 200 && res.data.success) {
              this.dimMemberList = res.data.result;
            }
          });
        }, 200);
      } else {
        this.dimMemberList = [];
      }
    },
    // 根据id查找会员
    pitchMember() {
      getMemberById({ id: this.createCheckFrom.membersId }).then((res) => {
        // console.log(res);
        if (res.status === 200 && res.data.success) {
          this.memberName = res.data.result.memberName;
          this.memberPhone = res.data.result.memberMobile;
          this.memberImg = res.data.result.photoData;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 添加储物寄存
    addStorageRegister() {
      addStorageRegister({
        ...this.createCheckFrom,
        days:
          this.createCheckFrom.days == "everyNnum"
            ? this.selfNum * 1
            : this.createCheckFrom.days,
      }).then((res) => {
        // console.log(res);
        if (res.status === 200 && res.data.success) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.storageDialogClose();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 创建寄存订单弹窗关闭事件
    storageDialogClose() {
      this.storageDialog = false;
      this.getStorageRegisterList();
      this.$refs["createCheckFroms"].resetFields();
      this.memberName = "";
      this.memberPhone = "";
      this.memberImg = "";
      this.selfNum = "";
    },
    // 退租弹窗打开
    openBackMoney(row) {
      this.backMoney = true;
      this.id = row.id;
      this.getUserForSelect();
    },
    // 退租
    backMoneyTure() {
      refundDeposit({ id: this.id, ...this.retrogradationForm }).then((res) => {
        // console.log(res);
        if (res.status === 200 && res.data.success) {
          this.$message({
            message: "退租成功",
            type: "success",
          });
          this.backMoneyClose();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 退租弹窗关闭
    backMoneyClose() {
      this.backMoney = false;
      this.id = "";
      this.retrogradationForm.updateBy = "";
      this.retrogradationForm.updateDate = "";
      this.getStorageRegisterList();
    },
    // 打开续约
    onMoney(row) {
      this.onMoneyDialog = true;
      this.id = row.id;
    },
    // 关闭续租弹框
    onMoneyDialogClose() {
      this.onMoneyDialog = false;
      this.id = "";
      this.onDays = "";
      this.getStorageRegisterList();
    },
    // 续约
    renew() {
      renew({ id: this.id, renewDays: this.onDays }).then((res) => {
        // console.log(res);
        if (res.status === 200 && res.data.success) {
          this.$message({
            message: "续约成功",
            type: "success",
          });
          this.onMoneyDialogClose();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    changeRadio(val) {
      this.showeveryNum = val == "everyNnum" ? true : false;
      this.selfNum = "";
    },
    // 详情弹窗打开
    // openDetailsDialog() {
    //   this.detailsDialog = true;
    // },
    // 详情弹窗关闭
    // detailsDialogClose() {
    //   this.detailsDialog = false;
    // },
  },
};
</script>

<style scoped>
.colorBlue {
  color: #409eff;
}
.mb15 {
  margin-bottom: 15px;
}
.ml15 {
  margin-left: 15px;
}
.positionR {
  position: relative;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.btnClass {
  margin-right: 20px;
  margin-bottom: 10px;
}
.orderMain {
  padding: 30px;
}
.pageClass {
  margin: 30px 10px;
}
.width70 {
  width: 70%;
}
.width70 .el-input {
  width: 70%;
}
.storagePhoto {
  position: absolute;
  width: 130px;
  height: 130px;
  top: 0;
  right: 50px;
}
.storagePhoto img {
  width: 100%;
  height: 100%;
}
</style>
